import { render } from "./DashboardPreviewBanner.vue?vue&type=template&id=1e0e71b7&scoped=true"
import script from "./DashboardPreviewBanner.vue?vue&type=script&lang=js"
export * from "./DashboardPreviewBanner.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1e0e71b7"

export default script